// extracted by mini-css-extract-plugin
export default {"displayForDesktop":"_1UFY3k8u","panel":"_1MltniBe","panelChild":"_1wOg8KqK","desktopOnly":"_2hJI-aUq","visitorPanelText":"_3vDSgbrt","roleLinks":"_1EnvABsG"};